import LabeledSwitch from './LabeledSwitch';

export default LabeledSwitch;
